import { withTranslation } from "next-i18next";
import useResponsive from "@helpers/useResponsive";
import Footer from "@layouts/Footer";
import Mobile from "./lib/Mobile";
import Desktop from "./lib/Desktop";
import { useEffect } from "react";
import { useRouter } from "next/router";

const GetSupportLP: React.FC<any> = (props) => {
  const isMobile = useResponsive("sm");
  const router = useRouter();

  useEffect(() => {
    const { pathname } = router;

    router.beforePopState(({ as }) => {
      if (as.includes(`${pathname}?`)) {
        router.replace(`${pathname}`);
        return false;
      }

      return true;
    });
  }, [router]);

  if (isMobile) {
    return <Mobile isMobile={isMobile} {...props} />;
  }

  return (
    <>
      <Desktop isMobile={isMobile} {...props} />
      <Footer dataNavbar={props.dataNavbar} />
    </>
  );
};

export default withTranslation(["common", "faq"])(GetSupportLP);
